import { Component, EventEmitter, Input, Output, SimpleChange, SimpleChanges, OnChanges } from '@angular/core';

@Component({
  selector: 'pixl-password-strength',
  imports: [],
  templateUrl: './password-strength.component.html',
  styleUrl: './password-strength.component.scss'
})
export class PasswordStrengthComponent implements OnChanges {
  bars: string[] = [];

  @Input() public passwordToCheck?: string;

  @Output() passwordStrength = new EventEmitter<boolean>();

  private colors = ['darkred', 'orangered', 'orange', 'yellowgreen'];

  message?: string;
  messageColor?: string;

  checkStrength(password: string) {
    let force = 0;

    const regex = /[$-/:-?{-~!"^_@`[\]]/g;
    const lowerLetters = /[a-z]+/.test(password);
    const upperLetters = /[A-Z]+/.test(password);
    const numbers = /[0-9]+/.test(password);
    const symbols = regex.test(password);

    const flags = [lowerLetters, upperLetters, numbers, symbols];

    let passedMatches = 0;
    for (const flag of flags) {
      passedMatches += flag === true ? 1 : 0;
    }

    force += 2 * password.length + (password.length >= 10 ? 1 : 0);
    force += passedMatches * 10;

    force = password.length <= 6 ? Math.min(force, 10) : force;

    force = passedMatches === 1 ? Math.min(force, 10) : force;
    force = passedMatches === 2 ? Math.min(force, 20) : force;
    force = passedMatches === 3 ? Math.min(force, 30) : force;
    force = passedMatches === 4 ? Math.min(force, 40) : force;

    return force;
  }

  ngOnChanges(changes: SimpleChanges & { passwordToCheck?: SimpleChange }): void {
    const password = changes.passwordToCheck?.currentValue;

    this.setBarColors(4, '#DDD');

    if (password) {
      const pwdStrength = this.checkStrength(password);
      if (pwdStrength === 40) {
        this.passwordStrength.emit(true);
      }
      else {
        this.passwordStrength.emit(false);
      }

      const color = this.getColor(pwdStrength);
      this.setBarColors(color.index, color.color);

      switch (pwdStrength) {
        case 10:
          this.message = 'Unsicher';
          break;
        case 20:
          this.message = 'Unterdurchschnittlich';
          break;
        case 30:
          this.message = 'Durchschnittlich';
          break;
        case 40:
          this.message = 'Gut';
          break;
      }
    }
    else {
      this.message = '';
    }
  }

  private getColor(strength: number) {
    let index: number;

    if (strength === 10) {
      index = 0;
    }
    else if (strength === 20) {
      index = 1;
    }
    else if (strength === 30) {
      index = 2;
    }
    else if (strength === 40) {
      index = 3;
    }
    else {
      index = 4;
    }

    this.messageColor = this.colors[index];

    return {
      index: index + 1,
      color: this.colors[index],
    };
  }

  private setBarColors(count: number, color: string): void {
    for (let n = 0; n < count; n++) {
      this.bars[n] = color;
    }
  }
}
